import suitacase3DaysPNG from '../assets/images/suitcase-3-days.png';
import suitacase7DaysPNG from '../assets/images/suitcase-7-days.png';
import suitacase15DaysPNG from '../assets/images/suitcase-15-days.png';

export const suitcaseMontageData = [
  {
    id: 1,
    serviceImage: suitacase3DaysPNG,
    serviceName: 'Mala de viagem para 3 dias',
    numberOfDays: 3,
    originalPrice: 3990,
    creditPrice: 2990,
    pixPrice: 2990,
  },
  {
    id: 2,
    serviceImage: suitacase7DaysPNG,
    serviceName: 'Mala de viagem para 7 dias',
    numberOfDays: 7,
    originalPrice: 4990,
    creditPrice: 3990,
    pixPrice: 3990,
  },
  {
    id: 3,
    serviceImage: suitacase15DaysPNG,
    serviceName: 'Mala de viagem para 15 dias',
    numberOfDays: 15,
    originalPrice: 6990,
    creditPrice: 5990,
    pixPrice: 5990,
  },
];
